export enum OnOffStatus{
    On ="On",
    Off ="Off"
  }